import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-05",
  "use": "icon-attr-shape-05-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-05\"><path d=\"M25 18.976C25 23.968 20.957 28 15.952 28 11.042 28 7 23.968 7 18.976V5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol